import cx from 'classnames';
import { FormV2 } from 'components/ui';
import { ClearIndicator } from 'components/ui/Form/Select';
import { ChevronDown } from 'ethena-icons';
import { ClearIndicatorProps, Props } from 'react-select';
import RSAsyncSelect from 'react-select/async';
import css from './AsyncSelect.module.scss';

interface ISelectProps extends Props {
  alignMenu?: 'left' | 'right';
  errorMessage?: string;
  isFluidWidth?: boolean;
  isInvalid?: boolean;
}

export const AsyncSelect = ({
  className,
  components,
  errorMessage,
  isClearable,
  isFluidWidth,
  isInvalid,
  ...rest
}: ISelectProps) => (
  <div
    className={cx(css.asyncSelect, className, {
      [css.fluid]: isFluidWidth,
      [css.invalid]: isInvalid,
    })}
  >
    <RSAsyncSelect
      classNamePrefix="as"
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: () => <ChevronDown />,
        ClearIndicator: (props: ClearIndicatorProps) =>
          isClearable ? <ClearIndicator {...props} /> : null,
        ...components,
      }}
      isClearable={isClearable}
      {...rest}
    />
    <FormV2.Control.Feedback type="invalid">
      {errorMessage}
    </FormV2.Control.Feedback>
  </div>
);
